import { setupAxios } from "../app/modules/auth";
import { api } from "./APIMiddlewares";

export async function getProjectCodes() {
  const { token, tenantId } = setupAxios();

  return await api.get(
    "/project-codes?type=REAL&isActive=true",
    token,
    tenantId,
    false
  );
}